import React, { FC, useRef, useEffect } from 'react';
import { graphql } from 'gatsby';
import lottie from "lottie-web";

import { Grid, GridItem, GridItemTwo, GridItemThree, GridTwo } from './HomePlatform.styles';
import { Box, Container, Text, FileAsset } from '@mode/components';

type HomePlatformProps = {
  leftTitle: string;
  leftDescription: string;
  leftAnimation?: FileAsset;
  rightTitle: string;
  rightDescription: string;
  rightAnimation?: FileAsset;
}

export const HomePlatform: FC<HomePlatformProps> = ({
  leftTitle,
  leftDescription,
  leftAnimation,
  rightTitle,
  rightDescription,
  rightAnimation,
}) => {
  const leftAnimationRef = useRef(null);
  const rightAnimationRef = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: leftAnimationRef.current,
      path: leftAnimation.url,
      loop: false,
      renderer: "svg",
      autoplay: true
    })
    lottie.loadAnimation({
      container: rightAnimationRef.current,
      path: rightAnimation.url,
      loop: false,
      renderer: "svg",
      autoplay: true
    })
  }, [leftAnimation.url, rightAnimation.url])

  return (
    <Container collapseOnMobile css={{ color: '$g5' }}>
      <Grid>
        <GridItem>
          <Box>
            <Text textStyle="h2">{leftTitle}</Text>
            <Text textStyle="p1" css={{ pt: '$xxs' }}>{leftDescription}</Text>
          </Box>
          <Box ref={leftAnimationRef} css={{ width: '100%', height: '45%', top: '0', position: 'relative', zIndex: 5, 'svg': { transform: 'unset !important' }, '@md': { width: '150%', top: '24px', } }} />
        </GridItem>
        <GridItemTwo>
          <GridTwo>
            <GridItemThree />
            <GridItemThree />
          </GridTwo>
        </GridItemTwo>
        <GridItem>
          <Box ref={rightAnimationRef} css={{ width: '100%', height: '45%', position: 'relative', zIndex: 5, mb: '$xs', 'svg': { transform: 'unset !important' }, '@md': { width: '150%', right: '50%', mb: 0 } }} />
          <Box>
            <Text textStyle="h2">{rightTitle}</Text>
            <Text textStyle="p1" css={{ pt: '$xxs' }}>{rightDescription}</Text>
          </Box>
        </GridItem>
      </Grid>
    </Container>
  )
}

export const query = graphql`
  fragment HomePlatformContent on HomePlatform {
    _key
    leftTitle
    leftDescription
    leftAnimation {
      _createdAt
      size
      url
    }
    rightTitle
    rightDescription
    rightAnimation {
      _createdAt
      size
      url
    }
  }
`